import Home from "../_pages/Home";
import AccountSettings from "../_pages/AccountSettings";
import TermsAndConditions from "../_pages/TermsAndConditions";
import AboutSalah from "../_pages/AboutSalah";
import HelpAndSupport from "../_pages/HelpAndSupport";
import LiveTranscribe from "../utils/LiveTranscribe";

const ProtectedRotues = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/account-settings",
    element: <AccountSettings />,
  },
  {
    path: "/help-and-support",
    element: <HelpAndSupport />,
  },
  {
    path: "/stt-test",
    element: <LiveTranscribe />,
  },
  
];

export default ProtectedRotues;
